import { render, staticRenderFns } from "./DialogPreview.vue?vue&type=template&id=c5be514a"
import script from "./DialogPreview.vue?vue&type=script&lang=js"
export * from "./DialogPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports